import React from 'react';
import { useDispatch } from 'react-redux';
import { loadUserFromPartner } from '../../actions/user';

export const Partner = ({ match, history }) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loadUserFromPartner(match.params.guid, () => history.push('/')));
    }, []);

    return (
        <div className="flex flex-center flex-column">
            <h3>Logging into e4enable from partners.e4enable.com...</h3>
            <div>
                <i className="fa fa-spin fa-cog text-lg mr10" />
                Please Wait
            </div>
        </div>
    );
};

export default Partner;
